module.exports = __webpack_public_path__ + "static/bg-sec8-sm-d7f603aecee7adbd452b2c5bfccb6361.jpg";